<div class="wrapper {{ className }}">
  <div class="content">
    <img width="100" src="./assets/icons/{{ icon }}.svg" alt="icon" />

    @if (type === feedbackType.INSTRUMENT_TECHNICIAN) {
    <span class="text-center">
      <p class="message-type">{{ title }}</p>
      <p class="text mt-2">
        Senha criada com sucesso. Agora, <b>baixe o app e instale</b>, de acordo
        com a plataforma do seu celular e após isso, basta entrar com seu e-mail
        e com essa senha que você acabou de criar.

        <br />
        <br />
        Abra <b>no seu celular</b> um dos links abaixo:
      </p>

      <div class="d-flex flex-column gap-4">
        <app-black-button
          class="mt-4"
          iconName="bootstrapAndroid2"
          buttonText="Caso seu celular seja Android"
        ></app-black-button>
        <app-black-button
          class="mt-2"
          iconName="bootstrapApple"
          buttonText="Caso seu celular seja Iphone"
        ></app-black-button>
      </div>
    </span>

    } @if(type !== feedbackType.INSTRUMENT_TECHNICIAN){
    <span class="text-center">
      <p class="message-type">{{ title }}</p>
      <p class="text mt-2">{{ message }}</p>
    </span>
    } @if (className !== 'confirmation') {
    <button (click)="activeModal.close(true)" class="btn">Ok</button>
    } @if (className === 'confirmation' && type !==
    feedbackType.INSTRUMENT_TECHNICIAN) {
    <div class="row justify-content-around gap-3">
      <button (click)="activeModal.dismiss('Close click')" class="btn btn-info">
        Cancelar
      </button>
      <button (click)="activeModal.close(true)" class="btn">Ok</button>
    </div>
    }
  </div>
</div>
